var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"s-button"},[_c('div',{staticClass:"btn",class:{
    solidBtn: _vm.isSolid, emptyBtn: !_vm.isSolid,
    primary: _vm.theme === 'primary', default: _vm.theme === 'default', danger: _vm.theme === 'danger',
    large: _vm.size === 'large', normal: _vm.size === 'normal', small: _vm.size === 'small'
    },style:(_vm.btnStyle)},[_c('h1',{staticStyle:{"position":"relative","z-index":"9999"}},[_vm._t("default")],2),_vm._v(" "),(_vm.isSolid)?_c('div',{staticClass:"mask"}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36270386","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SBtn.vue
// module id = null
// module chunks = 